/** SGD left / amount right, 2 decimals; overdue uses a red capsule. */
export function MoneyAmount({
  value,
  overdue = false,
  className = '',
}: {
  value: number | null | undefined;
  overdue?: boolean;
  className?: string;
}) {
  if (value == null || !Number.isFinite(value)) {
    return <span className={['money-amount', className].filter(Boolean).join(' ')}>—</span>;
  }
  const abs = Math.abs(value);
  const num = abs.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const sign = value < 0 ? '−' : '';
  return (
    <span
      className={[
        'money-amount',
        overdue ? 'money-amount--overdue' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <span className="money-amount__ccy">
        {sign}SGD
      </span>
      <span className="money-amount__num">{num}</span>
    </span>
  );
}
